// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AlertType } from '@shared/utils/Alert/AlertConstants';
import { Instrument } from './Instrument';
export class Alert {
    constructor(dataCache, paramObj) {
        this.OrderPlaceParametrs = null;
        this.DataCache = dataCache;
        this.Account = paramObj.Account;
        this.Instrument = paramObj.Instrument;
        this.AlertType = paramObj.AlertType;
        this.Condition = paramObj.Condition;
        this.Value = paramObj.Value;
        this.Importance = paramObj.Importance;
        this.AfterExecute = paramObj.AfterExecute;
        this.Action = paramObj.Action;
        this.Notification = paramObj.Notification;
        this.Expiration = paramObj.Expiration;
        this.IsAllowOTHTrading = paramObj.IsAllowOTHTrading;
        this.MessageText = paramObj.MessageText;
        if (paramObj.OrderPlaceParametrs) {
            this.OrderPlaceParametrs = paramObj.OrderPlaceParametrs;
        }
        this.Active = paramObj.IsActive;
        this.AlertId = paramObj.AlertId;
        this.leverageValue = paramObj.leverageValue || null;
    }
    CanLocateOnChart(instrument) {
        return (Instrument.IsEqualInstrument(this.Instrument, instrument) &&
            this.Active &&
            this.AlertType !== AlertType.CHANGE &&
            this.AlertType !== AlertType.VOLUME);
    }
    GetDataToSend() {
        const data = new AlertSendToServerItem();
        data.Account = this.Account;
        data.Instrument = this.Instrument;
        data.AlertType = this.AlertType;
        data.Condition = this.Condition;
        data.Value = this.Value;
        data.Importance = this.Importance;
        data.AfterExecute = this.AfterExecute;
        data.Action = this.Action;
        data.Notification = this.Notification;
        data.Expiration = this.Expiration;
        data.IsAllowOTHTrading = this.IsAllowOTHTrading;
        data.MessageText = this.MessageText;
        if (this.OrderPlaceParametrs) {
            data.OrderPlaceParametrs = this.OrderPlaceParametrs.getDataForRequest();
        }
        data.Active = this.Active;
        data.AlertId = this.AlertId;
        if (this.leverageValue) {
            data.leverageValue = this.leverageValue;
        }
        return data;
    }
    dispose() {
        var _a;
        if ((_a = this.OrderPlaceParametrs) === null || _a === void 0 ? void 0 : _a.dispose) {
            this.OrderPlaceParametrs.dispose();
        }
    }
}
export class AlertSendToServerItem {
    constructor() {
        this.Instrument = null;
        this.AlertType = null;
        this.Condition = null;
        this.Value = null;
        this.Importance = null;
        this.AfterExecute = null;
        this.Action = null;
        this.Notification = null;
        this.Expiration = null;
        this.MessageText = null;
        this.OrderPlaceParametrs = null;
        this.Active = null;
        this.AlertId = null;
        this.Account = null;
        this.IsAllowOTHTrading = null;
    }
}
